/**
 * Farbpalette nach der Landeskarte der Schweiz (swisstopo LK25/LK100).
 * Nachempfunden anhand der Kartenblätter, nicht offiziell – alle Werte hier
 * zentral anpassbar.
 */
export const C = {
  // Grundflächen: die Landeskarte druckt auf Weiss
  paper: '#FFFFFF',
  settlement: '#E4E1D8',
  farmland: '#FBFBF6',
  grass: '#E9F1DB',
  forest: '#CFE5B4',
  forestEdge: '#B4D199',
  tree: '#4E7C3A',
  treeConifer: '#3C6630',
  scrub: '#E3EFCF',
  rock: '#EDEAE2',
  sand: '#F7F0DC',
  glacier: '#EAF6FB',

  // Wasser
  water: '#C3E2F2',
  waterEdge: '#4D9BC4',
  river: '#5AA8CE',
  waterLabel: '#2D7FA6',

  // Bauten: in der Landeskarte schwarz gefuellt, ohne Trennlinie -
  // aneinandergebaute Haeuser verschmelzen dort zu einer Masse
  building: '#1E1C19',
  // Fuer die Entzerrung in 3D: reines Schwarz schluckt jede Schattierung,
  // die Baukoerper waeren eine Teergrube. Ein Hauch heller macht Licht und
  // Schatten sichtbar, ohne die Karte aufzuhellen.
  building3d: '#2A2724',

  // Strassen – Werte aus den swisstopo-Kartenkacheln ausgemessen:
  // Autobahn kräftiges Amber mit dunkelbraunem Rand, Hauptstrasse lachsrosa,
  // Nebenstrasse blassgelb, Quartierstrasse weiss mit dunklem Rand
  motorway: '#F8B838',
  motorwayCase: '#6B4A08',
  trunk: '#F8C038',
  trunkCase: '#7A5610',
  primary: '#F2A892',
  primaryCase: '#B5674E',
  secondary: '#F8D86A',
  secondaryCase: '#9A7A28',
  tertiary: '#FFFFFF',
  tertiaryCase: '#7D7668',
  minor: '#FFFFFF',
  minorCase: '#6E685C',
  service: '#FFFFFF',
  serviceCase: '#9A9488',
  track: '#4A463E',
  path: '#6B655A',
  rail: '#C81818',
  railLight: '#D04038',
  aeroway: '#EDEAE2',

  // Höhenlinien
  contour: '#C79A6B',
  contourMain: '#A8703C',
  contourLabel: '#8A5E30',

  // Wanderwege (Landeskarte: rot gestrichelt)
  hiking: '#CC3A2B',

  // Grenzen. In der Landeskarte ist die Landesgrenze keine violette Linie,
  // sondern ein schmaler Strich mit breitem rosa Saum daneben - Saumfarbe aus
  // einer echten Kachel gemessen (#DEA2C0), Strichfarbe wie in swisstopos
  // eigenen Vektorkacheln.
  borderCountry: '#C35591',
  borderBand: '#DEA2C0',
  // Gleiche Farbe wie die Landesgrenze: swisstopo unterscheidet Kanton und
  // Land nicht ueber Farbe oder Strichelung, sondern nur ueber die Breite.
  // Gestrichelt ist dort nur, was umstritten oder Bezirks-/Gemeindeebene ist.
  borderCanton: '#C35591',

  // Schrift
  ink: '#1A1915',
  inkSoft: '#56524A',
  // Hausnummern stehen bei swisstopo in einem neutralen Mittelgrau
  houseNumber: '#464646',
  // Kein harter weisser Rand: swisstopo legt in den eigenen Vektorkacheln
  // einen schmalen, weichen Schleier unter die Schrift - 242er Grau bei 90%,
  // damit sie auch ueber schwarzen Gebaeudebloecken lesbar bleibt, ohne
  // aufgeklebt zu wirken. Gewaesser und Hoehenlinien bekommen den Schleier
  // im eigenen Ton, sonst sitzt ein grauer Fleck im Blau.
  halo: 'rgba(242, 242, 242, 0.9)',
  haloWater: 'rgba(220, 241, 254, 0.9)',
  haloContour: 'rgba(238, 238, 238, 0.9)',
  haloFactor: 1,
  peak: '#5A4F3E',

  // POI-Akzent
  poi: '#7A4E24',
  favorite: '#141414'
};

// Source Sans 3: humanistische Grotesk in der Tradition von Frutiger/Univers,
// OFL-lizenziert. Glyphen erzeugt tools/build-glyphs.mjs, ausgeliefert unter /fonts/.
// Genau ein Name je Stapel: unsere Glyphen liegen als statische Dateien, und
// ein Verzeichnis "A,B" gibt es dort nicht - Rueckfallschriften koennte nur ein
// Glyph-Server zusammensetzen.
/**
 * Schwarzweiss-Variante. Bewusst von Hand gesetzt statt gerechnet: eine reine
 * Entsättigung macht Lachsrosa und Gelb zum selben Grau. Hier trägt stattdessen
 * die Helligkeit die Hierarchie, wie auf der grauen Landeskarte.
 */
export const GREY = {
  paper: '#FFFFFF',
  settlement: '#ECECEC',
  farmland: '#FAFAFA',
  grass: '#F2F2F2',
  forest: '#DEDEDE',
  forestEdge: '#C2C2C2',
  tree: '#7E7E7E',
  treeConifer: '#616161',
  scrub: '#E7E7E7',
  rock: '#E9E9E9',
  sand: '#F1F1F1',
  glacier: '#F6F6F6',

  water: '#E3E3E3',
  waterEdge: '#8C8C8C',
  river: '#9C9C9C',
  waterLabel: '#6B6B6B',

  building: '#1A1A1A',
  building3d: '#2E2E2E',

  motorway: '#C6C6C6',
  motorwayCase: '#3A3A3A',
  trunk: '#D2D2D2',
  trunkCase: '#4C4C4C',
  primary: '#DADADA',
  primaryCase: '#585858',
  secondary: '#E6E6E6',
  secondaryCase: '#6C6C6C',
  tertiary: '#FFFFFF',
  tertiaryCase: '#7E7E7E',
  minor: '#FFFFFF',
  minorCase: '#8C8C8C',
  service: '#FFFFFF',
  serviceCase: '#A4A4A4',
  track: '#4A4A4A',
  path: '#6E6E6E',
  rail: '#262626',
  railLight: '#5C5C5C',
  aeroway: '#E9E9E9',

  contour: '#C0C0C0',
  contourMain: '#949494',
  contourLabel: '#6E6E6E',

  hiking: '#5A5A5A',

  borderCountry: '#8E8E8E',
  borderBand: '#CFCFCF',
  borderCanton: '#AFAFAF',

  ink: '#1A1A1A',
  inkSoft: '#5A5A5A',
  houseNumber: '#4A4A4A',
  halo: 'rgba(242, 242, 242, 0.9)',
  haloWater: 'rgba(236, 236, 236, 0.9)',
  haloContour: 'rgba(238, 238, 238, 0.9)',
  haloFactor: 1,
  peak: '#4A4A4A',

  poi: '#4A4A4A',
  favorite: '#141414'
};

/**
 * Umschaltbare Paletten des Kartenbilds. Auf dem Luftbild ist die Vorlage
 * ein Foto statt einer Kartengrundlage - dort traegt die Schrift doch einen
 * Halo, sonst verschwindet sie in dunklen Waeldern und Schattenhaengen.
 */
export const PALETTES = {
  farbig: C,
  /**
   * "Hell": dieselbe Landeskarte, aber mit grauen Gebaeuden statt schwarzen.
   * swisstopo fuehrt neben der Landeskarte genau dafuer die Leichte Basiskarte
   * (Gebaeude hsl(220,10%,82%)) - weil automatisch gesetzte Beschriftung auf
   * schwarzen Bloecken nicht lesbar ist. Die gedruckte Karte loest das durch
   * Platzierung von Hand, was eine Webkarte nicht kann.
   */
  hell: {
    ...C,
    // Fast weiss: bei dieser Fuellung traegt die Kante das Bild, nicht die
    // Flaeche. Neutral grau, kein Blaustich.
    building: '#F0F0F0',
    buildingEdge: '#A0A0A0',
    building3d: '#E4E4E4',
    haloFactor: 1
  },
  sw: GREY,
  luftbild: {
    ...C,
    halo: 'rgba(255, 255, 255, 0.95)',
    haloWater: 'rgba(255, 255, 255, 0.95)',
    haloContour: 'rgba(255, 255, 255, 0.95)',
    haloFactor: 1.8
  }
};

/**
 * Roboto Condensed, aufgeteilt wie swisstopo ihre Frutiger-Schnitte verteilt:
 * Condensed Regular als Arbeitstier (Strassen, POI, Grenzen), Condensed Medium
 * fuer Ortsnamen, und die ganze Gelaendesprache - Hoehenkurven, Hoehenkoten,
 * Flurnamen, Gewaesser - kursiv. Schmal ist hier kein Geschmack, sondern
 * Platzgewinn auf einer dichten Karte, und Medium traegt die Ortsnamen auch
 * ueber schwarzen Gebaeudebloecken.
 *
 * Je Stapel genau ein Name: bei statisch ausgelieferten Glyphen fragt MapLibre
 * sonst ein Verzeichnis "A,B" an, das es nicht gibt.
 */
export const FONT = ['Roboto Condensed Regular'];
export const FONT_MEDIUM = ['Roboto Condensed Medium'];
export const FONT_BOLD = ['Roboto Condensed Bold'];
export const FONT_ITALIC = ['Roboto Condensed Italic'];
